import { FONT_WEIGHT, TEXT_LINE_HEIGHT, TEXT_SIZE } from '@makemydeal/dr-ui-bricks-components';
import styled from 'styled-components';

export const TradeInComponentContainer = styled.div`
    background-color: transparent !important;
    @media (max-width: 880px) {
        width: 100%;
    }
    overflow-y: unset !important;

    #dr-trade-ico iframe {
        height: revert-layer !important;
    }

    .dr-p202-page-ui {
        max-width: unset !important;
    }

    .header-logo {
        display: none;
    }

    .vehicle-info-page h2.page-title,
    .vehicle-info-page h6.page-subtitle,
    .improved-tradein-workflow-decision-page h2.page-title,
    .improved-tradein-workflow-decision-page h6.page-subtitle,
    .trade-in-summary-page h2.page-title,
    .trade-in-summary-page h6.page-subtitle {
        display: none !important;
    }

    .dr-action-footer-bar__skip-button {
        padding: 12px 20px !important;
        font-size: ${TEXT_SIZE.large} !important;
        line-height: ${TEXT_LINE_HEIGHT.large} !important;
        font-weight: ${FONT_WEIGHT.semibold} !important;
    }

    #action_footer_bar_action_button {
        padding: 12px 11px !important;
        font-size: ${TEXT_SIZE.large} !important;
        line-height: ${TEXT_LINE_HEIGHT.large} !important;
        font-weight: ${FONT_WEIGHT.semibold} !important;
    }

    .card-select-panel {
        box-shadow: none !important;
    }
    .card-select-button {
        padding: 0.25rem !important;
        height: 2rem !important;
        font-weight: 500 !important;
    }
    hr {
        margin-top: 30px !important;
    }

    /* Override the combined theme selector with higher specificity */

    .container-fluid .field-label {
        font-weight: ${FONT_WEIGHT.semibold} !important;
    }

    /* Apply wider layout to all child components */
    #dr-p202-vc-grid {
        gap: 1.25rem;
    }

    /* Override h6 line-height */
    h6 {
        line-height: 1.45 !important;
    }

    /* More specific h6 targeting */
    && h6,
    .dr-shopper-app h6,
    div h6 {
        line-height: 1.45 !important;
    }

    /* Override trade-in summary estimated value teaser font-weight */
    .trade-in-summary-page .trade-in-estimate .estimated-value__teaser {
        font-weight: ${FONT_WEIGHT.semibold} !important;
    }

    /* More specific targeting for trade-in summary */
    && .trade-in-summary-page .trade-in-estimate .estimated-value__teaser,
    .dr-shopper-app .trade-in-summary-page .trade-in-estimate .estimated-value__teaser {
        font-weight: ${FONT_WEIGHT.semibold} !important;
    }

    /* Iframe height override for trade-in ICO */
    .dr-page-iframe #dr-trade-ico iframe {
        height: revert-layer !important;
    }

    .vehicle-info-page .dr-action-footer-bar__skip-button,
    .trade-summary-footer .apply-trade-toggle {
        display: none;
    }

    .delete-trade-button {
        padding: 12px 20px !important;
        font-size: ${TEXT_SIZE.large} !important;
        line-height: ${TEXT_LINE_HEIGHT.large} !important;
        font-weight: ${FONT_WEIGHT.semibold} !important;
        color: ${({ theme }) => theme.uiBricks?.primaryAccentColor || '#01336b'} !important;
        border-color: ${({ theme }) => theme.uiBricks?.primaryAccentColor || '#01336b'} !important;
        &:hover {
            background-color: ${({ theme }) => theme.uiBricks?.primaryAccentColor || '#01336b'} !important;
            color: ${({ theme }) => theme.uiBricks?.modalBackgroundColor || '#fff'} !important;
        }
    }

    .back-button {
        color: ${({ theme }) => theme.uiBricks?.primaryAccentColor || '#01336b'} !important;
        &:hover {
            text-decoration: none !important;
        }
    }

    @media (max-width: 767px) {
        .trade-summary-footer {
            flex-direction: column-reverse;
        }
    }

    .vehicle-info-page .dr-action-footer-bar__back-link {
        visibility: hidden;
    }

    /* Override input fields for responsiveness */
    input#Zip,
    input#Mileage,
    div#ownership-input,
    div.select-field {
        min-width: 0 !important;
        width: clamp(14vw, 100%, 66vw) !important;
    }
    select,
    intput#trade-search-vin {
        min-width: 0 !important;
    }

    #vehicle-source__label,
    #vehicle-value__label,
    #comments__label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .kbb-trade-in-advisor-container {
        overflow: hidden !important;
    }

    .kbb-trade-in-advisor svg {
        min-width: 0 !important;
    }
    /* Increase error message font size by 0.1em */
    .error-message {
        font-size: 0.85rem;
    }
`;
